import * as types from 'modulesV2/constants';

export const initializeWelcomeBack = (user) => ({
  type: types.INITIALIZE_WELCOME_BACK,
  user,
});


export const setWelcomeBackUiIsVisible = (isVisible) => ({
  type: types.SET_WELCOME_BACK_UI_STATE,
  isVisible,
});
